import { createFileRoute } from '@tanstack/react-router'
import WritingSettings from '@/pages/settings/writing'

export const Route = createFileRoute(
  '/(protected)/settings/writing'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <WritingSettings />
}
